import React from 'react'

const ChangeFlow = ({
  setMobileMessages,
  setRbmType,
  rbmTypeName,
  setRbmElements,
  children
}) => {
  return (
    <div className="w-full">
      {children}
    </div>
  )
}

export default ChangeFlow
